import { MenuItem } from '@blueprintjs/core'
import { ItemModifiers, ItemRendererProps, Select2 } from '@blueprintjs/select'
import { Button } from '@ui'
import { useRef, useState } from 'react'

export interface SelectItem<T> {
  value: string
  title: JSX.Element | string
  data?: T
}

interface SelectProps<T> {
  items: SelectItem<T>[]
  title?: string
  width?: string | number
  noResults?: JSX.Element
  onSearch?: (query: string) => void
  onItemSelect: (param: SelectItem<T>) => void
  itemRenderer?: (item: SelectItem<T>, params: ItemRendererProps<HTMLLIElement>) => JSX.Element
  itemListPredicate?: (query: string, items: SelectItem<T>[]) => SelectItem<T>[]
}

export default function <T>({
  items,
  title,
  onItemSelect,
  width,
  itemRenderer,
  noResults,
  onSearch,
  itemListPredicate,
}: SelectProps<T>) {
  const [filteredData, setFilteredData] = useState<SelectItem<T>[]>([])
  const selectRef = useRef<HTMLDivElement | null>(null)
  const dropdownWidth = (selectRef.current?.getBoundingClientRect().width || 300) - 10
  return (
    <Select2
      items={filteredData.length ? filteredData : items}
      popoverProps={{ minimal: true }}
      noResults={<div style={{ width: dropdownWidth }}>{noResults || 'No results found.'}</div>}
      onQueryChange={onSearch}
      itemRenderer={(i, params) =>
        itemRenderer ? (
          itemRenderer(i, params)
        ) : (
          <MenuItem
            key={i.value}
            style={{ width: dropdownWidth }}
            text={i.title}
            onClick={params.handleClick}
          />
        )
      }
      filterable={true}
      onItemSelect={(i) => onItemSelect?.(i)}
      itemListPredicate={itemListPredicate}>
      <div ref={selectRef} style={{ width: width || 300 }}>
        <Button
          text={title}
          style={{ width: width || 300, justifyContent: 'space-between' }}
          rightIconName="chevron-down"
        />
      </div>
    </Select2>
  )
}
